const advantages = [
  { icon: 'ri-award-line', title: '18+ лет практики', desc: 'Более 18 лет в корпоративном обучении. Сотни успешных проектов и тысячи обученных сотрудников в разных отраслях и странах.' },
  { icon: 'ri-building-2-line', title: '100+ корпоративных проектов', desc: 'Опыт работы с компаниями от 20 до 1000+ сотрудников в производстве, IT, ритейле, финансовом секторе и услугах.' },
  { icon: 'ri-presentation-line', title: '450+ обучающих программ', desc: 'Разработано и проведено более 450 тренингов и программ обучения под задачи конкретных компаний.' },
  { icon: 'ri-user-star-line', title: '4500+ обученных сотрудников', desc: 'Более 4500 участников прошли обучение. География: Беларусь, Россия, Казахстан, Израиль.' },
  { icon: 'ri-settings-3-line', title: 'Индивидуальная разработка', desc: 'Каждая программа создаётся под задачи конкретной компании. Никаких типовых решений и шаблонных тренингов.' },
  { icon: 'ri-tools-line', title: '80% практики', desc: 'Минимум теории, максимум отработки. Кейсы и упражнения на реальном материале компании-заказчика.' },
  { icon: 'ri-user-heart-line', title: 'Сопровождение внедрения', desc: 'Программа не заканчивается в последний день тренинга. 2-3 месяца поддержки, чек-поинты и корректировка.' },
  { icon: 'ri-globe-line', title: 'Международный опыт', desc: 'Работа с компаниями из Беларуси, России, Казахстана и Израиля. Понимание специфики разных рынков и культур.' },
];

export default function WhyAlexeySivko() {
  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Почему программы Алексея Сивко отличаются
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          Системный подход, измеримые результаты и глубокая экспертиза — то, что отличает программы BusinessTraining.by
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {advantages.map((a, i) => (
            <div key={i} className="bg-white rounded-2xl p-6 border border-gray-100 hover:border-teal-200 hover:shadow-md transition-all group">
              <div className="w-12 h-12 bg-teal-600 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                <i className={`${a.icon} text-xl text-white`}></i>
              </div>
              <h3 className="font-bold text-gray-900 mb-2">{a.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{a.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}